import { FileUpload } from "@anchor/anchor-widgets/dist/lib/components";
import React from "react";

import "./PhotoUploadModal.css";

function PhotoUploadModal({
  modalOpen,
  handleModal,
  handleModalClose,
  files,
  handleFiles,
  fileChange,
  hanldePreviewModal,
  imageToPreview,
  previewModal,
  error,
  errorMessage,
  photoFor,
}) {
  if (!files) {
    return;
  }

  return (
    <>
  
      <FileUpload
        error={error}
        errorMessage={errorMessage}
        overrideSelectedFilePreview={true}
        fileActionsCallback={(e) => handleFiles(e)}
        selectedFiles={files.map((file) => ({
          name: file.name,
          size: file.size,
          type: file.type,
          preview: file.preview,
          photoFor: photoFor,
        }))}
        className="fileInput"
        fit="medium"
        id="fileUpload"
        // label="Upload"
        listStyle="line"
        modalProps={{
          heading: (
            <div style={{ backgroundColor: "#42B0D5", color: "white" }}>
              <p
                style={{ margin: 0, padding: "5px 20px", textAlign: "center" }}
              >
                <strong>Accepted image upload size: 50MB</strong>{" "}
              </p>
              <p
                style={{ margin: 0, padding: "5px 20px", textAlign: "center" }}
              >
                <strong>Accepted image format: .png</strong>{" "}
              </p>
              <p style={{ margin: 0, padding: "0 20px", textAlign: "center" }}>
                <strong>
                  Size of all images combined, for this section, should not
                  exceed 150MB
                </strong>
              </p>
            </div>
          ),
          onClose: handleModalClose,
          open: modalOpen,
        }}
        uploadedFiles={
          [
        
          ]
        }
        uploadValidationConfig={{
          maximumFileSize: 51200,
          maximumUploadCount: 1,
          // maximumUploadSize: 6000,
        }}
        name="fileInput"
        onChange={(event) => {
          fileChange({ event, photoFor: photoFor });
        }}
        orientation="vertical"
        showFiles
        showUpload
        supportedFormats={["image/png"]}
        // uploadedFiles={[

        // ]}
        multiple={true}
        variant="modal"
      />


    </>
  );


}

export default PhotoUploadModal;
